import react from "react";
import { Typography, Box } from "@mui/material";
import muiTheme from "../../../../themes/muiTheme";

interface Props {
  currentPage: number;
  sectionPage: number;
  title: string;
  viewWidth: number;
  isOpen: boolean;
  isPortrait: boolean;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  closeDrawer: React.Dispatch<React.SetStateAction<boolean>>;
}
export const SectionButton = ({
  currentPage,
  sectionPage,
  title,
  viewWidth,
  isOpen,
  isPortrait,
  setPage,
  closeDrawer,
}: Props) => {
  return (
    <Box
      onClick={() => {
        if (sectionPage < 0) {
          return;
        }
        if (isPortrait) {
          closeDrawer(!isOpen);
        }
        setPage(sectionPage);
      }}
      sx={{
        width: !isPortrait ? 184 : viewWidth - 56,
        height: 28,
        px: 1.2,
        py: 0.4,
        alignItems: "center",
        borderRadius: 0,
        bgcolor: "white",
        cursor: "pointer",
        userSelect: "none",
        ":hover": {
          backgroundColor: isPortrait ? null : muiTheme.palette.grey[200],
        },
      }}
    >
      <Typography
        variant={isClickedSection(currentPage, sectionPage) ? "tl-b" : "tl-m"}
        sx={{
          py: 0.4,
          color: isClickedSection(currentPage, sectionPage)
            ? muiTheme.palette.blue[500]
            : muiTheme.palette.grey[900],
        }}
      >
        {title}
      </Typography>
    </Box>
  );
};

function isClickedSection(currentPage: number, sectionPage: number) {
  return currentPage === sectionPage;
}
